export const FIELD_NOT_AVAILABLE_MESSAGE = 'The value for this field was not found in this document';
